import { useContext } from 'react';
import dataApplicationsContext from '../../context/dataApplicationsContext';
import { useGetAllTopicsQuery } from '../../slices/topicsApiSlice';
import CardHelpLink from './CardHelpLink';
import UserGoBack from '../user/UserGoBack';
import RightPartContent from './RightPartContent';
import { sortByCustomOrder } from '../../components/utils';
import LoaderMenu from '../skeletons/LoaderMenu';

const Menus = ({ goBackLinks, multiMenus, desiredOrder }) => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { data: topics, isLoading, isSuccess, isError, error } = useGetAllTopicsQuery();

  if (isLoading) return <LoaderMenu />

  const isSmallDevise = windowWidth < 900;

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo=' '
      />
      <div className="help-content-container">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            {multiMenus.map((menu, index) => {
              const topicsFiltered = topics.filter(article => (article.component === menu.filter) || menu?.moreIds?.includes(article.id_topic));
              const topicsSorted = desiredOrder ? sortByCustomOrder(topicsFiltered, desiredOrder) : topicsFiltered;

              return (
                <div className="help-links-part mb-48" key={'menu-' + index}>
                  {menu.title && <p className="fw-600 fz-20 mb-24">{menu.title}</p>}
                  {topicsSorted.map((article, index) => {
                    return (
                      <CardHelpLink key={index}
                        title={article.title} link={article.link} slug={article.slug}
                        slugClass='fw-600 fz-14 mb-8 op-7' description={article.description}
                        containerClass={`help-link-container ${index === 0 ? 'pt-0' : ''}`} titleClass="help-link-text" descriptionClass="help-description fz-14 op-7" 
                      />
                    )
                  })}
                </div>
              )
            })}
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default Menus